export const SECTION_COMMAND = {
    CLOSE: 'close',
    OPEN: 'open'
};

export const SECTION_ICONS = {
    name: {
        closed: 'norgie-closed',
        opened: 'norgie-opened'
    }
};
